'use strict';

const USER_DELETED = '@@app-model/USER_DELETED';
const ORGANIZATION_DELETED = '@@app-model/ORGANIZATION_DELETED';
const ORGANIZATION_PROFILE_DELETED = '@@app-model/ORGANIZATION_PROFILE_DELETED';
const PROJECT_DELETED = '@@app-model/PROJECT_DELETED';
const ASSET_DELETED = '@@app-model/ASSET_DELETED';
const ASSET_PROJECT_DELETED = '@@app-model/ASSET_PROJECT_DELETED';

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function userDeleted(id) {
  return {
    type: USER_DELETED,
    payload: {
      id,
    },
  };
}
userDeleted.TYPE = USER_DELETED;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function organizationDeleted(id) {
  return {
    type: ORGANIZATION_DELETED,
    payload: {
      id,
    },
  };
}
organizationDeleted.TYPE = ORGANIZATION_DELETED;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function organizationProfileDeleted(id) {
  return {
    type: ORGANIZATION_PROFILE_DELETED,
    payload: {
      id,
    },
  };
}
organizationProfileDeleted.TYPE = ORGANIZATION_PROFILE_DELETED;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function projectDeleted(id) {
  return {
    type: PROJECT_DELETED,
    payload: {
      id,
    },
  };
}
projectDeleted.TYPE = PROJECT_DELETED;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function assetDeleted(id) {
  return {
    type: ASSET_DELETED,
    payload: {
      id,
    },
  };
}
assetDeleted.TYPE = ASSET_DELETED;

/**
 *
 * @param {String} id
 * @return {ReduxAction}
 */
export function assetProjectDeleted(id) {
  return {
    type: ASSET_PROJECT_DELETED,
    payload: {
      id,
    },
  };
}
assetProjectDeleted.TYPE = ASSET_PROJECT_DELETED;



// WEBPACK FOOTER //
// ./src/js/app/model/actions/deletion.js